import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsDas_inv_string(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isDas_inv_string = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return ["Das_inv_string"].includes(protocol);
  }, [Iv_list, SelInverter]);

  return isDas_inv_string;
}
